// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `page-withdrawal-instadebit ion-list {
  padding-top: 5px;
}
page-withdrawal-instadebit ion-grid {
  padding: 0px !important;
}
page-withdrawal-instadebit ion-radio {
  margin: 8px;
  margin-left: 8px;
}
page-withdrawal-instadebit .ion-item {
  padding: 0px;
  margin: 0px;
  margin-bottom: 15px;
  width: 100%;
  border: solid 1px #000 !important;
}
page-withdrawal-instadebit .item-inner {
  padding-right: 0px !important;
}
page-withdrawal-instadebit .button-submit {
  width: 50%;
}

.payment-option {
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.payment-option img {
  max-width: 80%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/withdraw/withdrawal-instadebit/withdrawal-instadebit.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AAGI;EACI,uBAAA;AADR;AAII;EACI,WAAA;EACA,gBAAA;AAFR;AAKI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,iCAAA;AAHR;AAMI;EACI,6BAAA;AAJR;AAOI;EACI,UAAA;AALR;;AASA;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;AANF;AAOE;EACE,cAAA;AALJ","sourcesContent":["page-withdrawal-instadebit {\n    ion-list {\n        padding-top: 5px;\n    }\n\n    ion-grid {\n        padding: 0px !important;\n    }\n\n    ion-radio {\n        margin: 8px;\n        margin-left: 8px;\n    }\n\n    .ion-item {\n        padding: 0px;\n        margin: 0px;\n        margin-bottom: 15px;\n        width: 100%;\n        border: solid 1px #000 !important;\n    }\n\n    .item-inner {\n        padding-right: 0px!important;\n    }\n\n    .button-submit {\n        width: 50%;\n    }\n}\n\n.payment-option {\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n  img {\n    max-width: 80%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
